const HdRealImagesPerProduct = 2;

export default HdRealImagesPerProduct;
